import { Button, Typography, Dialog, DialogTitle, DialogActions } from '@mui/material'
import { useResponsiveTypography } from '../../utility/responsiveTypography'

const ConfirmationBox = ({ isDialogOpen, title, setIsDialogOpen, onYes = () => {} }) => {
  const { modelheading } = useResponsiveTypography()

  return (
    <Dialog
      open={isDialogOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      onClose={() => {
        setIsDialogOpen(false)
      }}
    >
      <DialogTitle style={{ fontSize: modelheading }} id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogActions>
        <Button
          color="primary"
          onClick={() => {
            setIsDialogOpen(false)
          }}
        >
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={onYes}>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  )
}
export default ConfirmationBox
